// ONE ACCOUNT'S STATEMENT, AS LIGHT AS THE REGISTER (UI rebuild batch 2) — what Money movements draws when the account
// filter names one account. Astra's register, with the Account seat (every line would name the same account) traded for
// the BALANCE right after each line — the bank-statement column the operator asked for on 17 Sept 2026, and the reason
// the filter exists. A line per currency the entry moved on that account (`linesOf`, newest first, the route's order);
// each line opens the same receipt. The opening and closing per currency are on the Totals link under the list.
import { Register, whenColumn, type RegisterColumn } from '../kit';
import { Figure } from '../../Ledger';
import { MovementFigure, linesOf, type MovementLineRow, type StatementLine } from '../../MovementTable';
import { displayAsset, fmtAmount } from '../../../lib/format';
import { Chevron, Direction, NameCell } from './MovementRegister';

const Balance = ({ l }: { l: StatementLine }) => (l.running !== null
  ? <span className="whitespace-nowrap"><Figure value={l.running} asset={l.asset} /> <span className="text-tg-hint">{displayAsset(l.asset)}</span></span>
  : null);

export function StatementRegister({ rows, showBalance, onOpen }: {
  rows: MovementLineRow[];
  /** Only once the Worker sends `legs` (an older one sends none; a column of blanks would read as "no balance"). */
  showBalance: boolean;
  onOpen: (m: MovementLineRow) => void;
}) {
  const lines = rows.flatMap(linesOf);
  const columns: RegisterColumn<StatementLine>[] = [
    whenColumn<StatementLine>((l) => l.m.at),
    { key: 'entry', head: 'Party / reference', width: 'w-[32%]', cell: (l) => <NameCell line={l} /> },
    { key: 'amount', head: 'Amount', align: 'right', width: 'w-[22%]', cell: (l) => <MovementFigure line={l} code /> },
    ...(showBalance ? [{ key: 'bal', head: 'Balance', align: 'right' as const, width: 'w-[20%]', cell: (l: StatementLine) => <Balance l={l} /> }] : []),
    { key: 'dir', head: 'Direction', align: 'right', cell: (l) => <Direction m={l.m} /> },
    { key: 'go', head: '', width: 'w-10', cell: () => <Chevron /> },
  ];
  return (
    <Register
      label="Account statement"
      columns={columns}
      rows={lines}
      rowKey={(l) => l.key}
      onOpen={(l) => onOpen(l.m)}
      card={(l) => ({
        title: (
          <>
            {/* the card's full width — see MovementRegister */}
            <span aria-hidden className="block h-0 w-screen max-w-full" />
            <NameCell line={l} card />
            <span className="mt-3 flex items-start justify-between gap-3">
              <MovementFigure line={l} code />
              <Direction m={l.m} />
            </span>
          </>
        ),
        figure: <Chevron />,
        meta: showBalance && l.running !== null ? `Balance ${fmtAmount(l.running, l.asset)} ${displayAsset(l.asset)}` : undefined,
      })}
    />
  );
}
